// extracted by mini-css-extract-plugin
export default {"container":"StepHeader_container__1t+Wg","title":"StepHeader_title__v3ErN","subtitle":"StepHeader_subtitle__3M3va"};